<template>
  <div class="relative" style="min-width: 200px">
    <input
      ref="order_code"
      type="text"
      :disabled="disabled"
      class="w-full border-0 bg-transparent p-0 placeholder-gray-200 focus:border-0 focus:ring-0 sm:text-sm"
      placeholder="Kode Faktur"
      v-model="search"
      @change="onSearch"
    />
    <button
      v-if="!disabled"
      type="button"
      @click="onOpenOrderModal"
      class="absolute inset-y-0 top-0 right-0 flex cursor-pointer items-center pl-3"
    >
      <Icon icon="heroicons:magnifying-glass-circle-solid" class="h-5 w-5" />
    </button>

    <OrderModal
      :visible="modal.visible"
      :request-params="filterOrderParams"
      @close="modal.visible = false"
      @click-order="onChangeOrder"
    />

    <Loading v-if="loading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { requestMixin } from '../../mixins/request/request';
import OrderModal from './OrderModal.vue';

export default {
  mixins: [requestMixin],
  components: { OrderModal },
  props: {
    disabled: Boolean,
    value: null,
    filterOrderParams: Object,
    originalSearch: String,
  },
  emits: ['input', 'change'],
  computed: {
    search: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      loading: false,
      modal: {
        index: null,
        visible: false,
      },
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onChangeOrder(order) {
      this.$emit('change', {
        order,
        closeModal: () => (this.modal.visible = false),
      });
    },
    onOpenOrderModal(index) {
      this.modal.index = index;
      this.modal.visible = true;
    },
    async onSearch() {
      this.loading = true;

      const [order, err] = await this.searchOrder();

      if (err) {
        this.search = this.originalSearch;

        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('change', { order });
      }

      this.loading = false;
    },
    async searchOrder() {
      const [res, err] = await this.request(`/api/v1/orders`, {
        params: {
          'filter[origin_code]': this.search,
          'fields[simple-orders]': 'order_id,origin_code',
          ...this.filterOrderParams,
        },
      });

      if (err || !res.data.length) {
        return [null, err || 'Faktur tidak ditemukan'];
      }

      return [res.data[0], null];
    },
  },
};
</script>
